import {
  URL_LOGO
} from '../Action-type/Index';

const initialState = {
  logo: ''
}

function systemReducer(state = initialState, action) {
  // console.log('action', action)
  switch (action.type) {
    case URL_LOGO: return {
      logo: action.payload
    };
    default: return { ...state };
  }
}

export default systemReducer;